import React, { useLayoutEffect } from 'react';
import { NavLink } from 'reactstrap';
import { Route, Link, Switch, BrowserRouter } from 'react-router-dom';
import Navigation from './components/NavigationBar';
import Clients from './app/clients/index';
import Login from './app/login/index';
import Users from './app/users/index';
import Admin from './app/admin/index';
import ProtectedRoute from './components/NavigationBar/ProtectedRoute';
import Error from './app/error/index';
import { initLogging } from './logging';
import useUser from './hooks/useUser';
import ErrorBoundary from './components/ErrorBoundary';

const App = () => {
  const { email, firstName, lastName, userId, bundle, isAdmin } = useUser();

  useLayoutEffect(() => {
    initLogging();
  }, [email, firstName, lastName, userId, bundle]);

  return (
    <BrowserRouter>
      <header>
        <Navigation>
          <NavLink
            id="client"
            tag={Link}
            data-testid="client-link"
            to="/clients">
            Clients
          </NavLink>
          <NavLink id="users" tag={Link} data-testid="users-link" to="/users">
            Users
          </NavLink>
          {isAdmin && (
            <NavLink id="admin" tag={Link} data-testid="admin-link" to="/admin">
              Admin
            </NavLink>
          )}
        </Navigation>
      </header>
      <main>
        <ErrorBoundary>
          <Switch>
            <ProtectedRoute exact path="/clients" component={Clients} />
            <ProtectedRoute exact path="/users" component={Users} />
            <ProtectedRoute exact path="/admin" component={Admin} />
            <ProtectedRoute exact path="/" component={Clients} />
            <Route exact path="/login" component={Login} />
            <Route component={Error} />
          </Switch>
        </ErrorBoundary>
      </main>
    </BrowserRouter>
  );
};

export default App;
